<template>
    <div class="simple-form">
        <div class="form-group">
            <div class="form-label">
                <label>名称</label>
            </div>
            <div class="form-value">
                <span>{{bizArea.name}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>外部系统编号</label>
            </div>
            <div class="form-value">
                <span>{{bizArea.code}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>说明</label>
            </div>
            <div class="form-value">
                <span>{{bizArea.desc}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>创建人</label>
            </div>
            <div class="form-value">
                <span>{{bizArea.creatorName}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>创建时间</label>
            </div>
            <div class="form-value">
                <span>{{bizArea.createTime}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>状态</label>
            </div>
            <div class="form-value">
                <span>{{bizArea.disabled ? '已禁用' : '已启用'}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>禁用人</label>
            </div>
            <div class="form-value">
                <span>{{bizArea.disablerName || '无'}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>禁用时间</label>
            </div>
            <div class="form-value">
                <span>{{bizArea.disableTime || '无'}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>禁用原因</label>
            </div>
            <div class="form-value">
                <span>{{bizArea.disableCause || '无'}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import bizAreaApi from '../../api/bizArea'

    export default{
        name: 'swb-retailer-biz-area-detail',
        desc: '经营区域详情',
        props: {
            areaId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                bizArea: {}
            }
        },
        created: function () {
            //
            if(!Utils.isNoB(this.areaId)) {
                this.getBizAreaDetail();
            }
        },
        methods: {
            getBizAreaDetail: function () {
                let self = this;
                let postData = {};
                postData.id = self.areaId;
                //
                let msgBoxDlg = MsgBox.loading();
                bizAreaApi.getRetailerBizArea(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let bizArea = result.data;
                        self.bizArea = Utils.merge({}, bizArea);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/bizArea/RetailerBizAreaDetail.vue